import React, { useEffect, useState } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import Sidebar from './partial/Sidebar';
import Header from './partial/Header';
import toast, { Toaster } from 'react-hot-toast';
import DeleteModal from './partial/DeleteModal';
import { FaEdit } from "react-icons/fa";


import ChangePassword from './partial/ChangePassword';
import { useAllReferencePackagesQuery, useDeleteReferencePackageMutation, useUpdateReferencePackageMutation } from '../../redux/API/ReferenceApi';
import { ImgUrl, referencePackageImgUrl } from '../Constant';

const AdminRelatedPackages = () => {
  const [newClass, setNewClass] = useState('');
  const [newSidebarClass, setNewSidebarClass] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeletId] = useState('');
  const { data, refetch } = useAllReferencePackagesQuery(); 
  
  
    const [deletePackage] = useDeleteReferencePackageMutation()  // API hook for deleting a package
  const [updatePackage] = useUpdateReferencePackageMutation();  // API hook for updating package status

  const handleShow = (id) => {
    setDeletId(id);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await deletePackage(deleteId).unwrap();
      setShowModal(false);
      refetch();
      toast.success('Package Deleted Successfully');
    } catch (error) {
      setShowModal(false);
      toast.error('Something went wrong, Please try again later');
    }
  };



  const handleToggle = () => {
    setNewClass(newClass === '' ? 'main-active' : '');
    setNewSidebarClass(newSidebarClass === '' ? 'closed' : '');
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <>
      <Toaster position='top-right' />
      <Sidebar newSidebarClass={newSidebarClass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} setShowPass={setShowPass} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Reference Packages
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link to="/admin/addrelatedpack
            " className="btn btn-primary">
              Add Package <FaPlus />
            </Link>
          </div>
          <div className="card p-4">
            <div className="table-wrapper w-100 overflow-x-auto">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Image</th>
                    <th scope="col">Name</th>
                    <th scope="col">Price</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
  {data && data.relatedPackages ? (
    data.relatedPackages.map((relatedItem, index,row) => (
      <tr key={relatedItem._id}>
        <td>{index + 1}</td>
        <td>
          <img
            src={`${ImgUrl}${referencePackageImgUrl}${relatedItem?.image}`}
            alt={relatedItem?.name}
            width={100}
          />
        </td>
        <td className="text-capitalize">{relatedItem?.name}</td>
        <td>₹{relatedItem?.price}</td>

        <td>
  <Link 
    to={`/admin/edit-relatedpack/${relatedItem.slug}`} 
    className="text-primary me-3"
  >
    <FaEdit />
  </Link>
  <Link
    className="text-danger"
    onClick={() => handleShow(relatedItem._id)}
  >
    <FaTrash />
  </Link>
</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">No related packages found</td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <DeleteModal
          title={"Package"}
          handleDelete={handleDelete}
          setShowModal={setShowModal}
        />
      )}

      {showPass && <ChangePassword setShowPass={setShowPass} />}
    </>
  );
};

export default AdminRelatedPackages;
